export class CandidateInterviewSendNotificationRequest {
    public constructor(
        public candidateConcurrencyToken: string,
        public subject: string,
        public recipientUserIds: number[],
    ) {}
}
